<template>
    <span>{{prefix}}<k-num :value="value / 100" :sign="sign" :unit="unit" :skin="skin" :fixed="fixLength" /></span>
</template>

<script>
    import {isNumeric} from '../../utils/base'

    export default {
        name: 'k-money',
        props: ['value', 'sign', 'skin', 'unit', 'fixed', 'prefix'],
        computed: {
            fixLength() {
                let {fixed} = this
                if(!isNumeric(fixed)) {
                    fixed = 2
                }
                return fixed
            }
        }
    }
</script>
